import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
  useRef,
  useEffect
} from "react";
import {
  Drawer,
  Button,
  Steps,
  Form,
  Input,
  Radio,
  notification,
  Space,
  Select,
  Alert,
  Upload,
} from "antd";
import { InboxOutlined } from "@ant-design/icons";
import documentManagementAPI from "../../../../restAPI/DocumentManagement";
import { decodeToken } from "react-jwt";
import { useSelector } from "react-redux";
const Context = React.createContext({
  name: "Default",
});
const { Step } = Steps;
const { TextArea } = Input;
const onSearch = (value) => {
  console.log("search:", value);
};
const StepForm = forwardRef((props, ref) => {
  const [currentStep, setCurrentStep] = useState(0);
  const { token } = useSelector((state) => state.auth);
  const [showUploadList, setShowUploadList] = useState(true);
  const [visible, setVisible] = useState(false); // Track drawer visibility
  const [transactionType, setTransactionType] = useState("Accounts receivable");
  const [errors, setErrors] = useState({});
  const [attachments, setAttachment] = useState([]);
  const [isbtnActive, setIsbtnActive] = useState(false);
  const { Dragger } = Upload;
  const formRef = useRef(null);

  const openNotificationWithIcon = (type, message, description, placement) => {
    api[type]({
      message: message,
      description: description,
      placement,
    });
  };

  useEffect(() => {
    //decode token
    if (token != null) {
      const decodedTokenValue = decodeToken(token);
    }
  }, [token]);

  // Expose methods to the parent component
  useImperativeHandle(ref, () => ({
    openDrawer: () => {
      setVisible(true); // Open drawer
    },
    closeDrawer: () => {
      setVisible(false); // Close drawer
    },
  }));
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (placement) => {
    api.success({
      message: `Success`,
      description: (
        <Context.Consumer>
          {({ name }) => `Successfully Saved`}
        </Context.Consumer>
      ),
      placement,
    });
  };
  const contextValue = useMemo(
    () => ({
      name: "Ant Design",
    }),
    []
  );

  const handleClearFields = () => {
    setAttachment([]);
    setIsbtnActive(false);
    formRef.current.resetFields(["attachments"]);
    setErrors({
      attachments: ""
    });
  };

  const config = {
    name: "file",
    multiple: true,
    showUploadList: { showUploadList },
    accept: ".pdf,.xls,.xlsx",
    onRemove: (file) => {
      const updatedAttachments = attachments.filter((item) => item.uid !== file.uid);
      setAttachment(updatedAttachments);
      setIsbtnActive(updatedAttachments.length > 0);
    },
    beforeUpload: (file, fileList) => {
      let newAttachments = [...attachments];

      for (let i = 0; i < fileList.length; i++) {
        const currentFile = fileList[i];
        if (!validateFile(currentFile, newAttachments)) {
          return Upload.LIST_IGNORE;
        }
        newAttachments.push(currentFile);
      }
      setAttachment(newAttachments);
      setIsbtnActive(newAttachments.length > 0);
      return false;
    },
    attachments,
  };

  const validateFile = (file, currentAttachments) => {
    const excelTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ];
    const pdfType = "application/pdf";

    const isExcel = excelTypes.includes(file.type);
    const isPDF = file.type === pdfType;
    const isFileSizeValid = file.size / 1024 / 1024 < 5;

    if (!isExcel && !isPDF) {
      setErrors({
        attachments: `${file.name} is not a valid file type. Only PDF and Excel files are allowed.`,
      });
      return false;
    }

    if (!isFileSizeValid) {
      setErrors({
        attachments: `${file.name} is larger than 5MB. Please upload a smaller file.`,
      });
      return false;
    }

    const hasExcel = currentAttachments.some(f => excelTypes.includes(f.type));
    const hasPDF = currentAttachments.some(f => f.type === pdfType);
    const pdfCount = currentAttachments.filter(f => f.type === pdfType).length;

    if ((isExcel && hasPDF) || (isPDF && hasExcel)) {
      setErrors({
        attachments: "You cannot upload both PDF and Excel files together. Upload only one type at a time.",
      });
      return false;
    }

    if (isExcel && hasExcel) {
      setErrors({
        attachments: "Only one Excel file is allowed.",
      });
      return false;
    }

    if (isPDF && pdfCount >= 10) {
      setErrors({
        attachments: "Only 10 PDF files are allowed.",
      });
      return false;
    }

    setErrors({
      attachments: ""
    });
    return true;
  };

  const handleUpload = async () => {

    if (localStorage.getItem("groupId") != null || localStorage.getItem("groupId") != undefined) {
      if (localStorage.getItem("companyId") != null || localStorage.getItem("companyId") != undefined) {
        const formData = new FormData();

        formData.append("groupId", localStorage.getItem("groupId"));
        formData.append("companyId", localStorage.getItem("companyId"));
        formData.append("transactionType", transactionType);

        attachments.forEach((file) => {
          if (
            file.type === "application/vnd.ms-excel" ||
            file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            formData.append("excel", file);
          } else if (file.type === "application/pdf") {
            formData.append("pdfs", file);
          }
        });
        if (attachments.length > 0) {

          await documentManagementAPI
            .uploadDocument(
              token,
              formData
            )
            .then((response) => {
              handleClearFields();
              openNotificationWithIcon(
                "success",
                "Successful",
                `${response.message}`,
                "bottomLeft"
              );
            })
            .catch((err) => {
              if (err.response) {
                openNotificationWithIcon(
                  "error",
                  "Extracting records failed",
                  `${err.response.data.message}`,
                  "bottomLeft"
                );
              } else {
                openNotificationWithIcon(
                  "error",
                  "Extracting records failed",
                  `${err.message}`,
                  "bottomLeft"
                );
              }
            });
        }
      }
      else {
        openNotificationWithIcon(
          "error",
          "Extracting records failed",
          "Please select a Company.",
          "bottomLeft"
        );
      }

    }
    else {
      openNotificationWithIcon(
        "error",
        "Extracting records failed",
        "Please select a Group.",
        "bottomLeft"
      );
    }

  }

  const next = () => setCurrentStep(currentStep + 1);
  const prev = () => setCurrentStep(currentStep - 1);

  const onClose = () => setVisible(false);

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      <Drawer
        title="Upload Document"
        width={700}
        visible={visible}
        onClose={() => setVisible(false)}
        footer={
          <div style={{ textAlign: "right" }}>
            <Button style={{ marginRight: 8 }} size="large">
              Clear
            </Button>

            <Button
              type="primary"
              size="large"
              onClick={() => openNotification("topRight")}
            >
              Upload
            </Button>
          </div>
        }
      >
        <div style={{ marginTop: 24 }}>
          <Form layout="vertical" ref={formRef}>
            <Form.Item
              label="Transaction Type"
              name="state"
              rules={[
                { required: true, message: "Transaction Type is required" },
              ]}
            >
              <Select
                showSearch
                disabled={true}
                defaultValue={transactionType}
                placeholder="Select Template Type"
                optionFilterProp="label"
                // onChange={onChange}.
                size="large"
                onSearch={onSearch}
                options={[
                  { value: "Accounts receivable", label: "Accounts Receivable" },
                  { value: "Accounts payable", label: "Accounts Payable" },
                ]}
              />
            </Form.Item>

            <Form.Item
              label="File"
              name="file"
              rules={[{ required: true, message: "File is required" }]}
            >
              <Dragger {...config}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">
                  Click or drag Excel file of PDF to this area to upload
                </p>
                <p className="ant-upload-hint">
                  Support for a single file upload.
                </p>
              </Dragger>
            </Form.Item>
          </Form>
        </div>
      </Drawer>
    </Context.Provider>
  );
});

export default StepForm;
